var cardListResize;

$(document).ready(function ()
{
  window.onpopstate = function (event)
  {
    if (event.state !== null)
    {
      app.itemInView = event.state.cardInView;
    }
    else
    {
      app.itemInView = 0;
    }
  };

  console.log("client width " + document.documentElement.clientWidth);
  console.log("per page currently " + model.perPage);

  var largeSize = 1201;
  var mediumSize = 992;

  var largePerPage = 10;
  var mediumPerPage = 8;
  var smallPerPage = 6;

  if (document.documentElement.clientWidth >= largeSize)
  {
    model.perPage = largePerPage;
  }
  else if (document.documentElement.clientWidth >= mediumSize)
  {
    model.perPage = mediumPerPage;
  }
  else
  {
    model.perPage = smallPerPage;
  }

  console.log("per page now " + model.perPage);

  var app = new Vue(
  {
    el: "#body-container",
    data:
    {          
      category: model.category,
      page: model.page,
      perPage: model.perPage,
      cardInView: 0,
      cards: model.cards,
      busy: false
    },
    mounted: function()
    {
      cardListResize = debounce(function()
      {
        console.log("resize fired");

        if (document.documentElement.clientWidth === windowWidth)
        {
          return;
        }
  
        windowWidth = document.documentElement.clientWidth;

        console.log("resize checking size and per page (" + windowWidth + ", " + app.perPage + ")");

        if ((windowWidth >= largeSize && app.perPage !== largePerPage) ||
            (windowWidth >= mediumSize && app.perPage !== mediumPerPage) ||
            (windowWidth < mediumSize && app.perPage !== smallPerPage))
        {
          var newPerPage = smallPerPage;

          if (windowWidth >= largeSize)
          {
            newPerPage = largePerPage;
          }
          else if (windowWidth >= mediumSize)
          {
            newPerPage = smallPerPage;
          }

          console.log("resize setting to " + newPerPage);
          app.perPage = newPerPage;
        }
      }, 100);
      
      clearLoading();
      window.addEventListener("resize", cardListResize);
    },
    methods:
    {
      pageShown: function(info)
      {
        if (info.page !== this.page || info.perPage !== this.perPage || info.inView !== this.cardInView)
        {
          this.page = info.page;
          this.perPage = info.perPage;
          this.cardInView = info.inView;

          if (info.replace)
          {
            history.replaceState({ page: this.page, perPage: this.perPage, cardInView: this.cardInView }, "Page " + this.page, this.getPageHistoryUrl());
          }
          else
          {
            history.pushState({ page: this.page, perPage: this.perPage, cardInView: this.cardInView }, "Page " + this.page, this.getPageHistoryUrl());
          }
        }
      },

      getPageHistoryUrl: function()
      {
        return window.location.pathname + "?page=" + this.page;
      }
    }
  });
});


